module.exports = __webpack_public_path__ + "static/google-logo-5a13b05b8f73f1740e1fbb81a3471fbf.png";